export default __webpack_public_path__ + "static/media/card4.564b9d74.jpg";